import searchCache from 'owa-recipient-cache/lib/selectors/searchCache';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PersonaType from 'owa-service/lib/contract/PersonaType';

export function getPeopleSuggestionsFromCache(
    queryString: string,
    recipientsToExclude: { EmailAddress: EmailAddressWrapper }[]
): PersonaType[] {
    let rcTopFive = searchCache(queryString, 5 /* numberOfResults */, recipientsToExclude);

    if (rcTopFive.length == 0) {
        return [];
    }

    let personaTypeSet = rcTopFive.map(result => {
        return {
            EmailAddress: result.EmailAddress,
            PersonaId: result.PersonaId,
            ADObjectId: result.ADObjectId,
            PersonaTypeString: result.PersonaTypeString,
        } as PersonaType;
    });

    return personaTypeSet;
}
